export const TiposProcesosGestion = [
    {
        codigoProceso: 1,
        nombreProceso: "ANULAR"
    }, {
        codigoProceso: 2,
        nombreProceso: "GESTIONAR"
    }, {
        codigoProceso: 3,
        nombreProceso: "REENVIAR"
    }, {
        codigoProceso: 4,
        nombreProceso: "REPROCESAR"
    }, {
        codigoProceso: 5,
        nombreProceso: "REPROCESAR INGRESO"
    }, {
        codigoProceso: 6,
        nombreProceso: "PROCESAR JERARQUIA"
    }
];

export const obtenerProcesoGestion = (codigoProceso: number) => {
    return TiposProcesosGestion.find(tipoGestionProceso => tipoGestionProceso.codigoProceso === codigoProceso);
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/inconsistencias/modelo/TiposProcesosGestion.ts